import { render, staticRenderFns } from "./FormControlUsersGroupsRoles.vue?vue&type=template&id=e2a3d7bc&scoped=true"
import script from "./FormControlUsersGroupsRoles.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlUsersGroupsRoles.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlUsersGroupsRoles.vue?vue&type=style&index=0&id=e2a3d7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a3d7bc",
  null
  
)

export default component.exports